import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import {
	indexStaffingByProjectId,
	indexUsersActiveStaffings,
	showStaffing,
} from "~/modules/project/api/staffing/staffingApiDispatchers.ts";

const ENTITY_QUERY_KEY = "staffing";

export const PROJECTS_STAFFINGS_QUERY_KEY = (projectId: string) => [ENTITY_QUERY_KEY, { projectId }];
export const STAFFING_QUERY_KEY = (staffingId: string) => [ENTITY_QUERY_KEY, { staffingId }];

export const USERS_ACTIVE_STAFFINGS_QUERY_KEY = (userId: string) => [ENTITY_QUERY_KEY, { userId, "active": true }];
export const useStaffing = ({ projectId, staffingId, enabled = true }: {
	enabled?: boolean,
	projectId: string,
	staffingId: string,
}) => useQuery({
	queryKey: STAFFING_QUERY_KEY(staffingId),
	queryFn: () => showStaffing({ projectId, staffingId }).then(getDataFromResponse),
	enabled,
});

export const useProjectsStaffings = (projectId: string) => useQuery({
	queryKey: PROJECTS_STAFFINGS_QUERY_KEY(projectId),
	queryFn: () => indexStaffingByProjectId({ projectId }).then(getDataFromResponse),
	enabled: !!projectId,
});

// The invalidations use the key of `USERS_ACTIVE_STAFFINGS_QUERY_KEY` as a prefix, so they reach each month.
export const useUsersActiveStaffings = (userId: string, month: string) => useQuery({
	queryKey: [...USERS_ACTIVE_STAFFINGS_QUERY_KEY(userId), { month }],
	queryFn: () => indexUsersActiveStaffings({ userId, month }).then(getDataFromResponse),
	enabled: !!userId && !!month,
	// A month change keeps the old list until the new one arrives, so the page does not fall back to its loader.
	placeholderData: keepPreviousData,
});
